import React, { FC, PropsWithChildren } from "react";
import { Modal } from "react-bootstrap";
import { StyledModal } from "./Styles";

interface CustomModalProps extends PropsWithChildren {
  show: boolean;
  header: string;
  [key: string]: any;
}

const CustomModal: FC<CustomModalProps> = ({
  show,
  header,
  children,
  ...props
}) => {
  return (
    <StyledModal
      show={show}
      backdrop="static"
      keyboard={false}
      size="md"
      centered
      {...props}
    >
      <Modal.Header closeButton={props.backdrop}>
        <h2>{header}</h2>
      </Modal.Header>

      <Modal.Body>{children}</Modal.Body>
    </StyledModal>
  );
};

export default CustomModal;
